import { apiService } from '../APIService';
import { CRUDFactory } from '../CRUDFactory';

/**
 *  Список задач для заявок
*/
export const CRUDTodoLists = CRUDFactory('todo-lists');

export default {
  changeStatus(id) {
    return apiService.post(`/todo-lists/${id}/change-status`);
  },
};
